import service  from "@/utils/http";


//获取个人信息
export function personageData(data) {
  return service({
    url: "/user/getUserInfo",
    method: "post",
    data:data
  });
}



//设置个人信息
export function personageSet(data) {
  return service({
    url: "/user/setBaseInfo",
    method: "post",
    data:data
  });
}


//用户签名
export function personageSign(data) {
  return service({
    url: "/user/setSign",
    method: "post",
    data:data
  });
}
//修改头像
export function personageAvatar(data) {
  return service({
    url: "/user/setAvatar",
    method: "post",
    data:data
  });
}

//修改昵称
export function personageName(data) {
  return service({
    url: "/user/setNickName",
    method: "post",
    data:data
  });
}
//重置密码
export function personagePassword(data) {
  return service({
    url: "/user/setPassword",
    method: "post",
    data:data
  });
}
//用户注销
export function personageLogout(data) {
  return service({
    url: "/user/logout",
    method: "post",
    data:data
  });
}


